<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
#app {
  padding-top: 1rem;
  font-size: 0.36rem;
  font-family: 'NotoSansHans-Medium';
  color: #333333;
}
</style>
